import { List } from 'components/List/List';
import { useTranslation } from 'react-i18next';
import { leagueGroupName } from 'helpers/leagueGroupName';
import { ThemeIcon } from 'components/ThemeIcon/ThemeIcon';
import styles from './ListItem.module.css';
import { useContext, useEffect, useState } from 'react';
import { LeagueContext } from 'context/leagueContext';

interface Props {
  name: string;
  id: number;
  parentId: number;
  count?: string;
  subList: any[];
  isLief?: boolean;
  groupName?: string;
  groupCode?: string;
}
export const Listitem = ({
  name,
  id,
  parentId,
  count,
  subList,
  isLief = true,
  groupName,
  groupCode,
}: Props) => {
  const { i18n } = useTranslation();
  const [expanded, setExpanded] = useState<boolean>(false);
  const [isSelected, setSelected] = useState<boolean>(false);
  const { selectLeague, deselectLeague, leagues } = useContext(LeagueContext);

  const handleClick = () => {
    if (!isLief) {
      setExpanded(!expanded);
    } else {
      if (isSelected) {
        deselectLeague(id);
      } else {
        selectLeague(id, parentId, groupName ?? null);
      }
      setSelected(!isSelected);
    }
  };

  useEffect(() => {
    if (leagues.findIndex((x: any) => x.leagueId === id) === -1) {
      setSelected(false);
    }
  }, [leagues]);

  return (
    <div className={styles.container}>
      <div
        className={styles.wrapper}
        data-remove-border={isLief}
        onClick={handleClick}
        data-selected={isSelected}
        data-is-expanded={expanded}
      >
        {isLief && (
          <ThemeIcon
            icon="checkmark"
            alt="Checkmark"
            variant="inline"
            tone="content"
            active={isSelected}
          />
        )}
        <div className={styles.title} data-title-uppercase={!isLief}>
          {isLief ? name : leagueGroupName(name, groupCode, i18n.language)}
        </div>
        <div className={styles.count}>{count}</div>
      </div>
      <div className={styles.subListWrapper} data-is-expanded={expanded}>
        {expanded && subList && subList.length > 0 && (
          <List items={subList} parentId={parentId} groupName={name} />
        )}
      </div>
    </div>
  );
};
